var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z",
    fill: "#FBE9E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6666 22.8333C28.6666 27 25.7499 29.0833 22.2833 30.2916C22.1017 30.3531 21.9045 30.3502 21.7249 30.2833C18.2499 29.0833 15.3333 27 15.3333 22.8333V17C15.3333 16.779 15.421 16.567 15.5773 16.4107C15.7336 16.2544 15.9456 16.1666 16.1666 16.1666C17.8333 16.1666 19.9166 15.1666 21.3666 13.9C21.5431 13.7491 21.7677 13.6663 21.9999 13.6663C22.2321 13.6663 22.4567 13.7491 22.6333 13.9C24.0916 15.175 26.1666 16.1666 27.8333 16.1666C28.0543 16.1666 28.2662 16.2544 28.4225 16.4107C28.5788 16.567 28.6666 16.779 28.6666 17V22.8333Z",
    stroke: "#BF360C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegular);
export default __webpack_public_path__ + "static/media/regular.78f4b41d80c8fc158e85fa17a6f906d0.svg";
export { ForwardRef as ReactComponent };